var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table',{attrs:{"resource":_vm.resource,"columns":_vm.columns,"suppress-route-handling":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Borders ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }